import {
  Typography,
} from '@mui/material';
import PassengerDetailsFields from './PassengerDetailsFields';
import { ListTypeMessage, Passenger } from '~/types';
import { Box } from '@mui/system';

interface PassengerDetailsProps {
  passengers: Passenger[];
  errors: ListTypeMessage[] | null,
  handleFieldChange: (fieldName: string, value: string, passengerId: string) => void;
  bookingContext: string;
}

const PassengerDetails = ({ bookingContext, passengers, errors, handleFieldChange }: PassengerDetailsProps) => {
  return (
    <Box sx={{ padding: '16px', margin: '20px 0' }}>
      {
        passengers.map((passenger, index) => {
          const passengerErrors = errors?.filter(item => item.index?.toString() === passenger.id) || [];

          const passengerType = `Passenger ${passenger.id} (${passenger?.passengerType?.toLowerCase().replace('held_', '')}).`;
          let passengerLabel = 'Adult';
          if (passengerType.includes('child')) {
            passengerLabel = 'Child';
          }
          if (passengerType.includes('infant')) {
            passengerLabel = 'Infant';
          }

          return (
            <Box key={passenger.id} sx={{ marginBottom: index != passengers.length - 1 ? 5 : 0 }}>
              <Typography variant="h6" sx={{ margin: '0' }}>
                Passenger {passengers.length === 1 ? 'details.' : passenger.id}
                {passengers.length > 1 && <Typography variant="body2" sx={{ display: 'inline' }}> ({passengerLabel})</Typography>}
              </Typography>
              <Typography variant="body2" sx={{ margin: 0 }}>
                Passenger first and last names must match exactly as they appear on travel documents
              </Typography>
              <PassengerDetailsFields
                key={`${passenger.id}-field`}
                passengerErrors={passengerErrors?.length ? passengerErrors[0].fields : {}}
                documentErrors={passengerErrors?.length && passengerErrors[0].children?.length ? passengerErrors[0].children[0].fields : {}}
                passenger={passenger}
                handleFieldChange={(fieldName: string, value: string) => handleFieldChange(fieldName, value, passenger.id)}
                bookingContext={bookingContext}
              />
            </Box>
          );
        })
      }
    </Box>
  );
};

export default PassengerDetails;
